'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPage$() {
}
export { $c_Lpresto_LoginPage$ as $c_Lpresto_LoginPage$ };
$p = $c_Lpresto_LoginPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPage$;
/** @constructor */
function $h_Lpresto_LoginPage$() {
}
export { $h_Lpresto_LoginPage$ as $h_Lpresto_LoginPage$ };
$h_Lpresto_LoginPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 284559736;
});
$p.l = (function() {
  return "LoginPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "LoginPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_LoginPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPage$, "presto.LoginPage$", ({
  LY: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_LoginPage$ as $d_Lpresto_LoginPage$ };
var $n_Lpresto_LoginPage$;
function $m_Lpresto_LoginPage$() {
  if ((!$n_Lpresto_LoginPage$)) {
    $n_Lpresto_LoginPage$ = new $c_Lpresto_LoginPage$();
  }
  return $n_Lpresto_LoginPage$;
}
export { $m_Lpresto_LoginPage$ as $m_Lpresto_LoginPage$ };
//# sourceMappingURL=presto.-Login-Page$.js.map
